import { FetcherServicesMasters } from "api";
import { InnerBanner } from "container/InnerpageBanner";
import { ArrowButton } from "molecules/ArrowButton";
import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { SectionBorder } from "molecules/SectionBorder";
import Divider from "molecules/SimpleBorder/Divider";
import { TitleHeading } from "molecules/TitleHeading";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const Our_services = () => {
  const {
    data: ourServiceData,
    loading: loadingourService,
    error: errorourService,
  } = useSelector((state) => state.ourServices);
  const [mastersData, setMastersData] = useState(null);

  const fetchMastersData = async () => {
    try {
      const data = await FetcherServicesMasters();
      console.log("FetcherServicesMasters", data);
      setMastersData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMastersData();
  }, []);
  // console.log(ourServiceData,"aaa")
  const [data, setData] = useState(null);

  useEffect(() => {
    if (ourServiceData && !loadingourService && !errorourService) {
      // Once data is available and loading is false, set the first object of the array
      setData(ourServiceData[0]);
    }
  }, [ourServiceData, loadingourService, errorourService]); // Dependency array ensures this effect runs when these values change

  // Show loading or error messages
  if (loadingourService) {
    return <div>Loading...</div>;
  }

  if (errorourService) {
    return <div>Error fetching data: {errorourService}</div>;
  }

  // Render the component when data is available
  if (!data) {
    return <div>No data available.</div>;
  }

  const develoeper_data = [
    {
      icon: "/media/diversity-icon.png",
      label: data?.heading_3_sub_1,
      details: data?.heading_3_sub_1_text,
    },
    {
      icon: "/media/equity-icon.png",
      label: data?.heading_3_sub_2,
      details: data?.heading_3_sub_2_text,
    },
    {
      icon: "/media/inclusion-icon.png",
      label: data?.heading_3_sub_3,
      details: data?.heading_3_sub_3_text,
    },
  ];
  const other_data = [
    {
      icon: "/media/diversity-icon.png",
      label: data?.heading_4_sub_1,
      details: data?.heading_4_sub_1_text,
    },
    {
      icon: "/media/equity-icon.png",
      label: data?.heading_4_sub_2,
      details: data?.heading_4_sub_2_text,
    },
    {
      icon: "/media/inclusion-icon.png",
      label: data?.heading_4_sub_3,
      details: data?.heading_4_sub_3_text,
    },
  ];
  return (
    <div className="backgroundThm mobileContainer">
      <div className="container  pl-0 pr-0">
        <Crumbs />
      </div>
      <div className="container  pl-0  pr-0">
        <InnerBanner
          bannertext={
            data?.main_header_text ||
            "Lorem Ipsum is simply dummy text of the printing and typesetting in..."
          }
          innertitle="Our Services"
          bannerimg={data?.banner_image || "/media/inner-page-banner.png"}
        />
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0">
          <div className="container   pl-0 pr-0">
            <div className="grid section-title pr-0">
              <div className="lg:col-4 md:col-5 sm:col-12 pl-0 pr-0  py-0 ">
                <TitleHeading title={data?.heading_1} className="mt-0 " />
              </div>
              <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                <div className="grid">
                  <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                    <DetailBox
                      details={data?.heading_1_text}
                      className="  mt-0 mb-3 p-0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container  pl-0 pr-0 pt-2">
            <Divider />
          </div>
        </section>
      </div>
      {mastersData?.map((item) => {
        const manage_data = [
          {
            icon: "/media/diversity-icon.png",
            label: item?.sub_heading_1,
            details: item?.sub_heading_1_description,
          },
          {
            icon: "/media/equity-icon.png",
            label: item?.sub_heading_2,
            details: item?.sub_heading_2_description,
          },
          {
            icon: "/media/inclusion-icon.png",
            label: item?.sub_heading_3,
            details: item?.sub_heading_3_description,
          },
        ];
        return (
          <div className="container pl-0 pr-0 ">
            <section className="section-padding1 px-0 pt-0 ">
              <div className="container   pl-0 pr-0">
                <div className="grid section-title  p-0">
                  <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                    <TitleHeading title={item?.title} className="mt-0 mb-3" />
                  </div>
                  <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                    <div className="grid">
                      <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                        <DetailBox
                          details={item?.description}
                          className="  mt-0 mb-3 p-0"
                        />
                      </div>
                      <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
                        <div className="flex justify-content-start">
                          <ArrowButton
                            width="170"
                            buttonText={item?.hyperlink_text}
                            bgColor="#CDC08B"
                            textColor="#000000"
                            url={item?.hyperlink_link}
                            className="ml-0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid mt-6 left-border-listing  p-0   ">
                  {manage_data.map((item) => (
                    <div className="lg:col-4 md:col-4 sm:col-4 OurServiceBorderTop  column-box  bg-blue">
                      <a href="" className="text-black-900 no-underline">
                        <h4 className="text-4xl  font-medium mt-3 mb-3 text-black-alpha-90 eb-garamond-font">
                          {item.label}
                        </h4>
                        <DetailBox details={item.details} className="" />
                      </a>
                    </div>
                  ))}
                </div>
              </div>

              <div className="container  pl-0 pr-0  borderSpacing">
                <Divider />
              </div>
            </section>
          </div>
        );
      })}

      {/* <div className="container pl-0 pr-0 ">
        <section className="section-padding1 px-0 pt-0 ">
          <div className="container   pl-0 pr-0">
            <div className="grid section-title  p-0">
              <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                <TitleHeading title={data?.heading_2} className="mt-0 mb-3" />
              </div>
              <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
                <div className="grid">
                  <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                    <DetailBox
                      details={data?.heading_2_text}
                      className="  mt-0 mb-3 p-0"
                    />
                  </div>
                  <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
                    <div className="flex justify-content-start">
                      <ArrowButton
                        width="170"
                        buttonText={data?.heading_2_hyperLink_text}
                        bgColor="#CDC08B"
                        textColor="#000000"
                        url={data?.heading_2_hyperLink_link}
                        className="ml-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid mt-6 left-border-listing  p-0   ">
              {manage_data.map((item) => (
                <div className="lg:col-4 md:col-4 sm:col-4 OurServiceBorderTop  column-box  bg-blue">
                  <a href="" className="text-black-900 no-underline">
                    <h4 className="text-4xl  font-medium mt-3 mb-3 text-black-alpha-90 eb-garamond-font">
                      {item.label}
                    </h4>
                    <DetailBox details={item.details} className="" />
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div className="container  pl-0 pr-0  borderSpacing">
            <Divider />
          </div>
        </section>
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0 pt-0  ">
          <div className="container   pl-0 pr-0">
            <div className="grid section-title">
              <div className="lg:col-4 md:col-5 sm:col-12 p-0">
                <TitleHeading title={data?.heading_3} className="mt-0 mb-3" />
              </div>
              <div className="lg:col-8 md:col-7 sm:col-12 pr-0 ">
                <div className="grid">
                  <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                    <DetailBox
                      details={data?.heading_3_text}
                      className="  mt-0 mb-3"
                    />
                  </div>
                  <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
                    <div className="flex justify-content-start ">
                      <ArrowButton
                        width="170"
                        buttonText={data?.heading_3_hyperLink_text}
                        bgColor="#CDC08B"
                        textColor="#000000"
                        url={data?.heading_3_hyperLink_link}
                        className="ml-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid mt-6 left-border-listing  ">
              {develoeper_data.map((item) => (
                <div className="lg:col-4 md:col-4 sm:col-4 OurServiceBorderTop column-box">
                  <a href="" className="text-black-900 no-underline">
                    <h4 className="text-4xl font-medium mt-3 mb-3 text-black-alpha-90 eb-garamond-font">
                      {item.label}
                    </h4>
                    <DetailBox details={item.details} className="" />
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="container  pl-0 pr-0   borderSpacing">
            <Divider />
          </div>
        </section>
      </div> */}

      {/* <section className="section-padding1 px-0 pt-0">
        <div className="container   pl-0 pr-0">
          <div className="grid section-title">
            <div className="lg:col-4 md:col-5 sm:col-12 p-0">
              <TitleHeading title={data?.heading_4} className="mt-0 mb-3" />
            </div>
            <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
              <div className="grid">
                <div className="lg:col-12 md:col-12 sm:col-12 p-0">
                  <DetailBox
                    details={data?.heading_4_text}
                    className="  mt-0 mb-3"
                  />
                </div>
                <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
                  <div className="flex justify-content-start">
                    <ArrowButton
                      width="170"
                      buttonText={data?.heading_4_hyperLink_text}
                      bgColor="#CDC08B"
                      textColor="#000000"
                      url={data?.heading_4_hyperLink_link}
                      className="ml-0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid mt-6 mb-2 left-border-listing">
            {other_data.map((item) => (
              <div className="lg:col-4 md:col-4 sm:col-4 OurServiceBorderTop column-box">
                <a href="" className="text-black-900 no-underline">
                  <h4 className="text-4xl font-medium mt-3 mb-3 text-black-alpha-90 eb-garamond-font">
                    {item.label}
                  </h4>
                  <DetailBox details={item.details} className="f" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section> */}
    </div>
  );
};
